import { createSlice } from "@reduxjs/toolkit";

const exceptionsSlice = createSlice({
    name: 'exceptions',
    initialState: {
        loading: 'idle',
        skuExceptions: [],
        exceptions: [],
    },
    reducers: {
        skuExceptionsAdded(state, action) {
            state.skuExceptions = action.payload;
        },
        exceptionsLoading(state, action) {
            if(state.loading == 'idle'){
                state.loading = 'pending';
            }
        },
        exceptionsSet(state, action) {
            if(state.loading == 'pending') {
                state.loading = 'idle';
                state.exceptions = action.payload;
            }
        },
    }
});

export const { skuExceptionsAdded, exceptionsLoading, exceptionsSet } = exceptionsSlice.actions;

export const setupSkuExceptionsAndSelections = (product) => dispatch => {
    const skuExceptions = product.sku_exceptions;

    dispatch(skuExceptionsAdded(skuExceptions));
    dispatch(exceptionsLoading());
    const normalized = normalizeSkuExceptions(skuExceptions);
    dispatch(exceptionsSet( normalized));

};

export const normalizeSkuExceptions = (exceptions) => {
    const normalized = [];
    // normalize disabled fields here
    exceptions.forEach((sku) => {

        const n = {
            id: sku.id,
            product_id: sku.product_id,
            name: sku.name,
            description: sku.description,
            exceptionFields: sku.attributes_map,
            within_module: sku.within_module,
            inclusion: sku.inclusion,
            inclusion_controlled_attributes: sku.inclusion_controlled_attributes
        };
        normalized.push(n);
    });

    return normalized;
}


const reducer = exceptionsSlice.reducer;
export default reducer;

